import { render, staticRenderFns } from "./PurchaseAndSaleTabItem.vue?vue&type=template&id=40ebfff8&scoped=true"
import script from "./PurchaseAndSaleTabItem.vue?vue&type=script&lang=js"
export * from "./PurchaseAndSaleTabItem.vue?vue&type=script&lang=js"
import style0 from "./PurchaseAndSaleTabItem.vue?vue&type=style&index=0&id=40ebfff8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ebfff8",
  null
  
)

export default component.exports